export function getContainersByTier(tierPattern) {
    return (smartBay) => {
        var _a;
        const containers = [];
        const { gridContent, allStacksKeys } = smartBay.getGridContent();
        // For each stack, get the container at the specified tier
        for (const stackKey of allStacksKeys) {
            const content = (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tierPattern];
            if (content) {
                containers.push(...content.containers);
            }
        }
        return {
            containers,
            tBaysStr: smartBay.tBaysStr,
            level: smartBay.level,
        };
    };
}
